module.exports = __webpack_public_path__ + "img/img_incorrecto.a03f3557.svg";